export default __webpack_public_path__ + "13d60eb06926692a0ea07b7f4a3a529f.svg";